import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Card from 'src/components/sharedComponents/Card/Card'
import CardBody from 'src/components/sharedComponents/Card/CardBody'
import CardHeader from 'src/components/sharedComponents/Card/CardHeader'
import CardIcon from 'src/components/sharedComponents/Card/CardIcon'
import { useHistory } from 'react-router-dom'
import { Box, Typography } from '@material-ui/core'
import chooseHeader from 'src/utils/chooseHeader'
import { clustersNames } from '@auteco/constants'
import { styles } from './styles'

const PortalCard = ({ history }) => {
  const hist = useHistory()
  const useStyles = makeStyles(styles)
  const classes = useStyles()
  const color = chooseHeader(history.id_tipo_entrada)
  const tipoInsight = (idTipoEntrada) => {
    switch (idTipoEntrada) {
      case '1':
        return 'Fact'
      case '2':
        return 'Actionable Fact'
      case '3':
        return 'Insight'
      default:
        return 'Sin Asignar'
    }
  }
  const clusterName = clustersNames.find(cluster => cluster.id === history?.cluster_id) || ''
  return (
    <Card className={classes.mainContainer}>
      <CardHeader
        color="customAuteco"
        stats
        icon
        onClick={() => hist.push(`/insight_factory/insight/${history.id}`)}
      >
        <CardIcon color={color} className={classes.cardIcon}>
          <h4 className={classes.title}>{history.titulo}</h4>
        </CardIcon>
      </CardHeader>
      <CardBody className={classes.cardBody}>
        <h4 className={classes.description}>{history.resumen}</h4>
        <Box className={classes.dateContainer}>
          <Typography className={classes.date}>
            {history.fecha_recepcion.slice(0, 10)}
          </Typography>
          <Typography className={classes.date}>{history.unidad}</Typography>
          <Typography className={classes.date}>
            {tipoInsight(history.id_tipo_entrada)}
          </Typography>
          <Typography className={classes.date}>
            Cluster: {clusterName.name || ''}
          </Typography>
        </Box>
      </CardBody>
    </Card>
  )
}
export default PortalCard
